const ELocalStorageKeys = {
  FB_URL: 'fbUrl',
}

export const LocalStorage = {
  setFeatureBranchUrl: (fbUrl) => window.localStorage.setItem(ELocalStorageKeys.FB_URL, fbUrl),

  getFeatureBranchUrl: () => window.localStorage.getItem(ELocalStorageKeys.FB_URL),

  removeFeatureBranchUrl: () => window.localStorage.removeItem(ELocalStorageKeys.FB_URL),
}



// WEBPACK FOOTER //
// ./src/utils/localStorage.js